import React from "react";
import { useNavigate } from "react-router-dom";
import ICICILogo from "../../assets/BankLogo/icici.png";
import AxisLogo from "../../assets/BankLogo/axis.png";
import HDFCLogo from "../../assets/BankLogo/hdfc.png";
import IDFCLogo from "../../assets/BankLogo/idfc.png";


const MortgageLoanBankOffer = () => {
  const navigate = useNavigate();
  const plans = [
    {
      loanType: "mortgage",
      title: "Mortgage Loan",
    },
  ];

  const handleApplyClick = (loanType) => {
    navigate("/otp-verification", { state: { loanType } });
  };

  const loanData = [
    {
      loanType: "Mortgage Loan",
      bank: "IDFC",
      loanAmount: "₹15 Cr",
      interestRate: "Starting @ 8.85%",
      tenure: "Up to 25 Years",
      tag: "Real Time Offer",
      bankLogo: IDFCLogo
    },
    {
      loanType: "Mortgage Loan",
      bank: "HDFC",
      loanAmount: "₹10 Cr",
      interestRate: "Starting @ 8.95%",
      tenure: "Up to 15 Years",
      tag: "Real Time Offer",
      bankLogo: HDFCLogo
    },
    {
      loanType: "Mortgage Loan",
      bank: "ICICI Bank",
      loanAmount: "₹10 Cr",
      interestRate: "Starting @ 9.5%",
      tenure: "Up to 15 Years",
      tag: "Real Time Offer",
      bankLogo: ICICILogo
    },
    {
      loanType: "Mortgage Loan",
      bank: "Axis Bank",
      loanAmount: "₹5 Cr",
      interestRate: "Starting @ 9.5%",
      tenure: "10 to 20 Years",
      tag: "Real Time Offer",
      bankLogo: AxisLogo
    },
  ];

  return (
    <div className="pricing-main-container">
      <h4 className="bank-offer-title">{loanData[0].loanType}</h4>
      <p className="bank-offer-description">
        “Salaried individuals with a{" "}
        <span className="highlight-rate">net salary above ₹50,000 P/m.</span>
        <br /> Self-employed individuals with an{" "}
        <span className="highlight-rate">
          annual turnover above ₹1 crore can apply here.</span>”
      </p>
      <div className="pricing-cards">
        {loanData.map((loan, index) => (
          <div key={index} className="pricing-card">
            <div className="bank-header">
              <img src={loan.bankLogo} alt={loan.bank} className="bank-logo" />
              <h3 className="bank-name">{loan.bank}</h3>
            </div>
            <p>
              <strong>Loan Amount:</strong> {loan.loanAmount}
            </p>
            <p>
              <strong>Interest Rate:</strong> {loan.interestRate}
            </p>
            <p>
              <strong>Tenure:</strong> {loan.tenure}
            </p>
            <p className="offer-tag">{loan.tag}</p>
            {plans.map((plan, index) => (
              <button
                className="apply-button"
                key={index}
                onClick={() => handleApplyClick(plan.loanType)}
              >
                Check Eligibility
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
export default MortgageLoanBankOffer;
